// extracted by mini-css-extract-plugin
export default {"dropzone":"attachments-field_dropzone__WXngS","submitBtn":"attachments-field_submitBtn__VT0MA","deleteBtn":"attachments-field_deleteBtn__eJtGl"};